"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISpiceModelSimulationTestSchema = exports.ISpiceModelSimulationControlledVariableSchema = exports.ISpiceModelSimulationVariableTemperatureSchema = exports.ISpiceModelSimulationRespondingVariableSchema = exports.ISpiceModelSimulationVariableDefinitionSchema = exports.ISpiceModelSimulationVariableBaseSchema = exports.ISpiceModelSimulationVariableSourceFunctionSchema = exports.ISpiceModelSimulationVariableSeriesValueSchemaT = exports.ISpiceModelSimulationVariableSeriesValueSchema = exports.ISpiceModelTestSchema = void 0;
const zod_1 = require("zod");
const SpiceSourceOpts_1 = require("./SpiceSourceOpts");
exports.ISpiceModelTestSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    sourceReferenceMetadata: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(),
});
exports.ISpiceModelSimulationVariableSeriesValueSchema = zod_1.z.object({
    type: zod_1.z.literal('series'),
    units: zod_1.z.enum(['voltage', 'current', 'power', 'frequency', 'phase']),
    steps: zod_1.z.array(zod_1.z.object({ step: zod_1.z.number(), value: zod_1.z.number() })),
});
const ISpiceModelSimulationVariableSeriesValueSchemaT = (tValue) => zod_1.z.object({
    type: zod_1.z.literal('series'),
    units: tValue,
    steps: zod_1.z.array(zod_1.z.object({ step: zod_1.z.number(), value: zod_1.z.number() })),
});
exports.ISpiceModelSimulationVariableSeriesValueSchemaT = ISpiceModelSimulationVariableSeriesValueSchemaT;
exports.ISpiceModelSimulationVariableSourceFunctionSchema = zod_1.z.object({
    type: zod_1.z.literal('source-function'),
    units: zod_1.z.enum(['voltage', 'current']),
    opts: SpiceSourceOpts_1.ISpiceSourceOptsSchema,
});
exports.ISpiceModelSimulationVariableBaseSchema = zod_1.z.object({
    type: zod_1.z.enum(['controlled', 'responding', 'temperature']),
    variable: zod_1.z.string(),
    value: exports.ISpiceModelSimulationVariableSeriesValueSchema,
});
exports.ISpiceModelSimulationVariableDefinitionSchema = exports.ISpiceModelSimulationVariableBaseSchema.extend({
    description: zod_1.z.string().optional(),
});
exports.ISpiceModelSimulationRespondingVariableSchema = exports.ISpiceModelSimulationVariableDefinitionSchema.extend({
    type: zod_1.z.literal('responding'),
});
exports.ISpiceModelSimulationVariableTemperatureSchema = zod_1.z.object({
    type: zod_1.z.literal('temperature'),
    value: zod_1.z.number(),
});
exports.ISpiceModelSimulationControlledVariableSchema = exports.ISpiceModelSimulationVariableDefinitionSchema.extend({
    type: zod_1.z.literal('controlled'),
    valueType: zod_1.z.enum(['voltage', 'current']),
    value: zod_1.z.union([
        (0, exports.ISpiceModelSimulationVariableSeriesValueSchemaT)(zod_1.z.enum(['voltage', 'current'])),
        exports.ISpiceModelSimulationVariableTemperatureSchema,
        exports.ISpiceModelSimulationVariableSourceFunctionSchema,
    ]),
});
exports.ISpiceModelSimulationTestSchema = exports.ISpiceModelTestSchema.extend({
    type: zod_1.z.literal('simulation'),
    harness: zod_1.z.string().optional(),
    variables: zod_1.z.array(zod_1.z.union([exports.ISpiceModelSimulationRespondingVariableSchema, exports.ISpiceModelSimulationControlledVariableSchema])),
});
//# sourceMappingURL=SpiceModelTests.js.map